import React, { useState } from "react";
import { Yonela } from "../../assets";
import { useLocation } from "react-router-dom";
import Bookings from "./Bookings";
import Profile from "./Profile";
import { FaDeleteLeft } from "react-icons/fa6";
import Dashboard from "./Dashboard";
import { MdDashboard, MdOutlineDashboard } from "react-icons/md";

const UserAccount = () => {
  const [tab, setTab] = useState("settings");
  const { pathname } = useLocation();
  let subpage = pathname.split("/")?.[2];
  if (subpage === undefined) {
    subpage = "profile";
  }

  function linkClasses(type = null) {
    let classes = "inline-flex gap-1 py-2 px-6 rounded-md cursor-pointer";
    if (type === subpage) {
      classes += " bg-primary text-white";
    } else {
      classes += " bg-gray-200";
    }
    return classes;
  }

  return (
    <div className="max-w-[1170px] px-5 mx-auto">
      <div className="flex gap-10">
        <div className="pb-[50px] px-[30px] rounded-md flex flex-col items-center">
          <div className="flex items-center justify-center">
            <figure className="w-[100px] h-[100px] rounded-full border-2 border-solid border-dr_gray">
              <img src={Yonela} alt="" className="w-full h-full rounded-full" />
            </figure>
          </div>
          <div className="text-center mt-4">
            <h3 className="text-[16px] leading-[30px] text-dr_gray font-bold">
              Yonela Johannes
            </h3>
            <p className="text-dr_gray text-[14px] leading-6 font-medium">
              johannesyonela@gmail.com
            </p>
          </div>
          <div className="mt-10">
            <button className="flex items-center gap-2 bg-h4 py-1 px-2 leading-7 rounded-md">
              <FaDeleteLeft size={18} />
              Delete account
            </button>
          </div>
        </div>
        <div className="w-full h-full flex-1">
          <div className="flex flex-row gap-8 h-min w-max">
            <div
              onClick={() => setTab("settings")}
              className={
                linkClasses("bookings") +
                ` ${tab === "settings" ? "bg-hl" : " "}`
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                />
              </svg>
              My profile
            </div>
            <div
              onClick={() => setTab("bookings")}
              className={
                linkClasses("bookings") +
                ` ${tab === "bookings" ? "bg-hl" : " "}`
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                />
              </svg>
              My bookings
            </div>
            <div
              onClick={() => setTab("dashboard")}
              className={
                linkClasses("dashboard") +
                ` ${tab === "dashboard" ? "bg-hl" : " "}`
              }
            >
            <MdOutlineDashboard size={18} />
              Dashboard
            </div>
          </div>
          <div className="mt-[5rem]">
            {tab === "bookings" ? <Bookings /> : ""}
            {tab === "settings" ? <Profile /> : ""}
            {tab === "dashboard" ? <Dashboard /> : ""}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAccount;
